import { ErrorView } from "common/components/error";
import { Component } from "react";
import { connect } from "react-redux";

import {
    REPORT_FETCH,
    AVAILABLE_REPORTS_FETCH_DATA
} from "common/actions/reports";

import { ReportListRedux } from "./reportsAvailable";
import { ReportView } from "./report";

import "./reports.scss";
import "common/components/configTable/table.scss";

const mapStateToProps = (state) => ({
    id: state.reports.options.id,
    page: state.reports.options.page,
    lastItemId: state.reports.options.lastItemId,
    itemId: state.reports.options.itemId,
    walk: state.reports.options.walk,
    
    all_reports: state.reports.all_reports
});

const mapDispatchToProps = {
    REPORT_FETCH,
    AVAILABLE_REPORTS_FETCH_DATA
};

class ReportsPageRedux extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false,
            reportsCache: {}
        };
    }
    
    componentDidMount() {
        if (!this.props.all_reports?.data?.length) {
            this.props.AVAILABLE_REPORTS_FETCH_DATA();
        }
    }
    
    componentDidCatch(error) {
        // Display fallback UI
        this.setState({
            error
        });
    }
    
    findReport = (reportId) => this.props.all_reports.data?.find(({ _id, canonical_name }) => [_id, canonical_name].includes(reportId));

    cacheReportValues = (reportId, updatedValues) => {
        this.setState((prevState) => ({
            reportsCache: {
                ...prevState.reportsCache,
                [reportId]: {
                    ...prevState.reportsCache?.[reportId],
                    ...updatedValues
                }
            }
        }));
    };
    
    getCachedReportValues = (reportId) => (reportId in this.state.reportsCache ? this.state.reportsCache[reportId] : null);
    
    clearCache = () => this.setState({ reportsCache: {} });
    
    renderReport() {
        if (this.props.id === "none") {
            return null;
        }
        
        return (
            <ReportView
                key={`parent_${this.props.id}`}
                id={this.props.id}
                lastItemId={this.props.lastItemId}
                itemId={this.props.itemId}
                walk={this.props.walk}
                findReport={this.findReport}
                cacheReportValues={this.cacheReportValues}
                getCachedReportValues={this.getCachedReportValues}
                isMainReport
            />
        );
    }
    
    render() {
        if (this.state.error) {
            return <ErrorView error={this.state.error}/>;
        }
        
        return (
            <div className="admin-reports full-page-wrapper">
                {(this.props.itemId === null) && (
                    <div className="available">
                        <div className="reports-label">Available reports</div>
                        <ReportListRedux
                            id={this.props.id}
                            all_reports={this.props.all_reports}
                            clearCache={this.clearCache}
                        />
                    </div>
                )}
                {this.renderReport()}
            </div>
        );
    }
}
export const ReportsPage = connect(mapStateToProps, mapDispatchToProps)(ReportsPageRedux);
